export default __webpack_public_path__ + "static/media/v.32e13e9b.svg";